import { inject } from "@angular/core";
import { UnsavedGuardService } from "./route.service";
import { CanDeactivateFn } from "@angular/router";

export const unsavedGuard: CanDeactivateFn<any> = async () => {
    const unsavedGuardService: any = inject(UnsavedGuardService);
    const canDeactivate = unsavedGuardService.allFormsClean();
    if (!canDeactivate) {
        const shouldLeave = await unsavedGuardService.showWarning();
        return shouldLeave;
    }
    return true;
}